import { SVGs } from "../../assets";
import { Flex } from "antd";
import Text from "../text";
import React from "react";
import Button from "../button";

const statusData = {
  404: { image: SVGs.balloons404 },
  200: { image: SVGs.balloons },
};

const Result = ({ status, title = "", subTitle = "", buttons = [] }) => {
  return (
    <Flex align="center" justify="center" className="p-48-t">
      <div style={{ maxWidth: "37.3rem" }}>
        <img src={statusData[status]?.image} className="m-15-b" />
        {!!title && <Text level={3} children={title} />}
        {!!subTitle && (
          <Text color="secondary" className="m-15-t" children={subTitle} />
        )}
        {!!buttons.length && (
          <Flex
            gap={"1rem"}
            className="m-40-t"
            children={React.Children.toArray(
              buttons.map((button) => <Button type="primary" {...button} />)
            )}
          />
        )}
      </div>
    </Flex>
  );
};

export default Result;
